<template>
    <div class="json-request nested-card">
        <v-layout row wrap>
            <v-flex xs4>
                <label>Type</label>
                <v-autocomplete
                    :items="methodItems"
                    item-text="name"
                    item-value="value"
                    v-model="dataObject.type"
                    :error="!dataObject.type"
                    :error-messages="!dataObject.type? 'Type is Required':'' "
                    outline
                    solo
                ></v-autocomplete>
            </v-flex>
            <v-flex xs8>
                <label>URL</label>
<!--                <v-text-field-->
<!--                        outline-->
<!--                        v-model="dataObject.url"-->
<!--                        :error="!dataObject.url || !common.validURL(dataObject.url)"-->
<!--                        :error-messages="!dataObject.url? 'URL is Required':'' || !common.validURL(dataObject.url)? 'URL is not valid':''"-->
<!--                >-->
<!--                </v-text-field>-->
                <vTextareaAutocomplete v-model="dataObject.url" :type="'textfield'"
                                       :validationRules="autocompleteJsonValidationRules"></vTextareaAutocomplete>
            </v-flex>
            <v-flex xs12>
                <label>Attributes</label>
                <v-autocomplete
                        :items="variables"
                        item-text="variable"
                        class="left-radius"
                        item-value="variable"
                        v-model="dataObject.user_attribute"
                        :error="!dataObject.user_attribute.length"
                        :error-messages="!dataObject.user_attribute.length? 'Attribute is Required':'' "
                        outline
                        chips
                        multiple
                        solo
                >
                    <template v-slot:selection="data">
                        <v-chip
                                :selected="data.selected"
                                close
                                color="#333"
                                @input="dataObject.user_attribute.splice(dataObject.user_attribute.indexOf(data.item.variable), 1)"
                        >
                            <strong>{{data.item.variable}}</strong>&nbsp;
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import common from "../../../../../utils/common"
    export default {
        name: "request",
        props: {
            dataObject: {
                type: Object,
                default: ()=>{
                    return {}
                }
            }
        },
        data() {
            return {
                common,
                methodItems: [
                    {name: 'GET' , value: 'get'},
                    {name: 'POST' , value: 'post'}
                    ],
                autocompleteJsonValidationRules: [
                    v => !!v || 'Url is Required'
                ]
            }
        },
        computed: {
            variables() {
                return this.$store.state.blocksBuild.variables
            }
        }
    }
</script>

<style scoped>

</style>